var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
export var ModalContext = React.createContext(null);
export var useModalContext = function (opts) {
    if (opts === void 0) { opts = {}; }
    var _a = opts.initialShow, initialShow = _a === void 0 ? false : _a;
    var _b = __read(React.useState(initialShow), 2), show = _b[0], setShow = _b[1];
    var toggleModal = function () { return setShow(function (prev) { return !prev; }); };
    var showModal = function () { return setShow(true); };
    var closeModal = function () { return setShow(false); };
    return {
        show: show,
        setShow: setShow,
        toggleModal: toggleModal,
        showModal: showModal,
        closeModal: closeModal,
    };
};
export var useModal = function () {
    var modalContext = React.useContext(ModalContext);
    if (!modalContext) {
        throw new Error('Context is undefined. Please verify you are calling useModal() within a Modal Step.');
    }
    return modalContext;
};
//# sourceMappingURL=ModalContext.js.map